var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayArrow = function SvgPlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "play-arrow_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "play-arrow_svg__play-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L9.54 5.98A.998.998 0 0 0 8 6.82",
    className: "play-arrow_svg__vector"
  }))));
};
export { SvgPlayArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5QbGF5IEFycm93PC90aXRsZT48ZyBjbGFzcz0icGxheS1hcnJvdyI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNOCA2LjgydjEwLjM2YzAgLjc5Ljg3IDEuMjcgMS41NC44NGw4LjE0LTUuMThhMSAxIDAgMCAwIDAtMS42OUw5LjU0IDUuOThBLjk5OC45OTggMCAwIDAgOCA2LjgyWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";